export default "__VITE_ASSET__ddcefce7__"